// import * as React from "react";
import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import MenuIcon from "@mui/icons-material/Menu";

import {
  toggleMobileSidebar,
  toggleSidebar,
} from "../../feature/sidebar/sidebarSlice";
import { logout } from "../../feature/login/loginSlice";
import { changeMode } from "../../feature/modeSlice";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const settings = ["Profile", "Account", "Dashboard"];

const Navbar = () => {
  const { mode, isChecked } = useSelector((state) => state.mode);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleModes = (e) => {
    if (e.target.checked === true) {
      dispatch(changeMode("light"));
    } else {
      dispatch(changeMode("dark"));
    }
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position='fixed'
      sx={{
        padding: "5px",
        // bgcolor: "#edf1f7",
        boxShadow:
          mode === "light"
            ? "0 0.5rem 1rem 0 rgb(44 51 73 / 10%)"
            : "0 0.5rem 1rem 0 #1a1f33",
      }}
    >
      <Toolbar>
        <img src='/public/Images/fruits.jpg' alt='' />
        <IconButton
          edge='start'
          color='navbarIconColor'
          aria-label='menu'
          sx={{ mr: 4, mt: 1, display: { xs: "none", lg: "block" } }}
          onClick={() => {
            dispatch(toggleSidebar());
          }}
        >
          <MenuIcon fontSize='medium' />
        </IconButton>
        <IconButton
          edge='start'
          color='navbarIconColor'
          aria-label='menu'
          sx={{ mr: 2, mt: 2, display: { xs: "block", lg: "none" } }}
          onClick={() => {
            dispatch(toggleMobileSidebar());
          }}
        >
          <MenuIcon fontSize='medium' />
        </IconButton>
        {/* <Divider orientation="vertical" flexItem  sx={{ mx: 2, mt:2, height:"40px",}}></Divider> */}
        <Typography
          variant='h1'
          component='a'
          color='secondary'
          aria-label='Logsitic Admin'
          onClick={() => {
            navigate("/");
          }}
          sx={{
            flexGrow: 1,
            cursor: "pointer",
            // bgcolor: "#edf1f7",
            borderLeft: `1px solid ${
              mode === "light" ? "#edf1f7" : "#151a30"
            } `,
            padding: "0 1.25rem",
          }}
        >
          Grocery Admin
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <MaterialUISwitch
                sx={{ m: 1 }}
                checked={isChecked}
                onChange={handleModes}
              />
            }
          />
        </FormGroup>

        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title='Open settings'>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt='Mactosys' src='/static/images/avatar/2.jpg' />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id='menu-appbar'
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={handleCloseUserMenu}>
                <Typography
                  onClick={() => {
                    navigate(`/${setting.toLowerCase()}`);
                  }}
                  textAlign='center'
                >
                  {setting}
                </Typography>
              </MenuItem>
            ))}
            <MenuItem>
              <Typography
                textAlign='center'
                onClick={() => {
                  dispatch(logout());
                }}
              >
                logout
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
